import gql from 'graphql-tag';

export const ADD_JOHARI_TEST = gql`
  mutation AddJohariTest($input: AddJohariTestInput!) {
    addJohariTest(input: $input)
  }
`;